import * as React from 'react';

import { SpacingSpace } from 'uitk-react-spacing/dist/types';

import { UitkCard, UitkCardContentSection } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType } from 'uitk-react-images';
import { UitkImageSkeleton, UitkTextSkeleton } from 'uitk-react-skeleton';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';

export const SearchListingPlaceholderSmall: React.FC = () => (
  <UitkSpacing className="listing__card" margin={{ block: 'four' }}>
    <UitkCard>
      <CardGalleryPlaceholder
        aspectRatio={UitkFigureAspectRatioType.R21_9}
        className="uitk-card-roundcorner-top-left uitk-card-roundcorner-top-right"
      />
      <CardContentPlaceholder />
    </UitkCard>
  </UitkSpacing>
);
SearchListingPlaceholderSmall.displayName = 'ListingPlaceholderSmall';

export const SearchListingPlaceholderLarge: React.FC = () => (
  <UitkSpacing className="listing__card" margin={{ block: 'four' }}>
    <UitkCard>
      <UitkLayoutGrid columns={3}>
        <UitkLayoutGridItem colSpan={1}>
          <CardGalleryPlaceholder
            aspectRatio={UitkFigureAspectRatioType.R21_9}
            className="uitk-card-roundcorner-top-left uitk-card-roundcorner-bottom-left"
          />
        </UitkLayoutGridItem>
        <UitkLayoutGridItem colSpan={2}>
          <UitkSpacing padding={{ blockend: 'twelve' }}>
            <div>
              <CardContentPlaceholder />
            </div>
          </UitkSpacing>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </UitkCard>
  </UitkSpacing>
);
SearchListingPlaceholderLarge.displayName = 'SearchListingPlaceholderLarge';

interface CardGalleryPlaceholderProps {
  aspectRatio: UitkFigureAspectRatioType;
  className: string;
}

const CardGalleryPlaceholder: React.FC<CardGalleryPlaceholderProps> = ({ aspectRatio, className }) => (
  <UitkFigure ratio={aspectRatio} className={className}>
    <UitkImageSkeleton />
  </UitkFigure>
);
CardGalleryPlaceholder.displayName = 'CardGalleryPlaceholder';

interface CardContentPlaceholderProps {
  border?: 'top' | 'bottom' | 'left' | 'right';
}

const CardContentPlaceholder: React.FC<CardContentPlaceholderProps> = ({ border }) => (
  <UitkCardContentSection border={border}>
    <PaddedSkeletonText />
    <PaddedSkeletonText blockend="twelve" type="secondary" />
  </UitkCardContentSection>
);
CardContentPlaceholder.displayName = 'CardContentPlaceholder';

interface PaddedSkeletonTextProps {
  blockend?: SpacingSpace;
  type?: 'primary' | 'secondary';
}

export const PaddedSkeletonText: React.FC<PaddedSkeletonTextProps> = ({ blockend, type }) => (
  <UitkSpacing margin={{ blockend: blockend || 'two' }}>
    <UitkTextSkeleton animation={true} type={type} />
  </UitkSpacing>
);
PaddedSkeletonText.displayName = 'PaddedSkeletonText';
